import axios from 'axios';
import { currentHttpOptions } from '../../../utils';
import { ScheduleTagType } from '../../../Enums';

const API_URL = '/api/v1/admin/adminSettings';

/**
 * @returns {Promise<ApiAdmin.GetAdminSettingsResponse>}
 */
export const GetSettings = () => {
    return axios.get(`${process.env.REACT_APP_API_DOTNET}${API_URL}/GetSettings`,
        currentHttpOptions());
}

/**
 * @returns {Promise<ApiAdmin.GetBreRuleSetsResponse>}
 */
export const getBreRuleSets = () => {
    return axios.get(`${process.env.REACT_APP_API_DOTNET}${API_URL}/GetBreRuleSets`,
        currentHttpOptions());
}

/**
 * @returns {Promise<ApiAdmin.GetWorkRuleListResponse>}
 */
export const GetWorkRulesList = () => {
    return axios.get(`${process.env.REACT_APP_API_DOTNET}${API_URL}/GetWorkRulesList`,
        currentHttpOptions());
}

/**
 * @returns {Promise<ApiAdmin.GetScheduleTagsResponse>}
 */
export const GetScheduleTags = () => {
    return axios.get(`${process.env.REACT_APP_API_DOTNET}${API_URL}/GetScheduleTags/${ScheduleTagType.Segment}`,
        currentHttpOptions());
}

/**
 * @returns {Promise<ApiAdmin.GetDataviewsListResponse>}
 */
export const GetDataviewsList = () => {
    return axios.get(`${process.env.REACT_APP_API_DOTNET}${API_URL}/GetDataviewsList`,
        currentHttpOptions());
}

/**
 * @returns {Promise<ApiAdmin.GetPaycodesListResponse>}
 */
export const GetPaycodesList = () => {
    return axios.get(`${process.env.REACT_APP_API_DOTNET}${API_URL}/GetPaycodesList`,
        currentHttpOptions());
}

/**
 * @returns {Promise<ApiAdmin.GetAwardingRulesListResponse>}
 */
export const GetAwardingRulesList = () => {
    return axios.get(`${process.env.REACT_APP_API_DOTNET}${API_URL}/GetAwardingRulesList`,
        currentHttpOptions());
}

/**
 * @returns {Promise<ApiAdmin.GetTimePeriodRatioOptionsResponse>}
 */
export const GetTimePeriodRatioOptions = () => {
    return axios.get(`${process.env.REACT_APP_API_DOTNET}${API_URL}/GetTimePeriodRatioOptions`,
        currentHttpOptions());
}